import {
  Github,
  Gitlab,
  ExternalLink,
  BookOpen,
  Package,
  Download,
  PlayCircle,
  Globe,
  Link as LinkIcon,
} from "lucide-react";

/**
 * Types de liens d'un projet — source de vérité partagée entre l'admin
 * (sélecteur du formulaire) et le public (icône + libellé par défaut).
 *
 * Doit rester aligné sur VALID_LINK_TYPES dans app/api/routes/api/projects.js :
 * un type inconnu y est ramené à "other".
 */
export const PROJECT_LINK_TYPES = [
  { type: "demo",     label: "Démo",          icon: ExternalLink },
  { type: "github",   label: "GitHub",        icon: Github },
  { type: "gitlab",   label: "GitLab",        icon: Gitlab },
  { type: "docs",     label: "Documentation", icon: BookOpen },
  { type: "npm",      label: "Paquet npm",    icon: Package },
  { type: "download", label: "Téléchargement", icon: Download },
  { type: "video",    label: "Vidéo",         icon: PlayCircle },
  { type: "website",  label: "Site web",      icon: Globe },
  { type: "other",    label: "Autre",         icon: LinkIcon },
];

export function getProjectLinkType(type) {
  return (
    PROJECT_LINK_TYPES.find((option) => option.type === type)
    || PROJECT_LINK_TYPES[PROJECT_LINK_TYPES.length - 1]
  );
}

/** Liens d'un projet, normalisés : le champ `links` peut arriver en JSON string. */
export function parseProjectLinks(value) {
  if (Array.isArray(value)) return value;
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}
